import React from 'react';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { Beneficiaries } from './utils/beneficiaryInterfaces';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { MainCategoryProps } from './MainCategory';
import { ErrorText } from './BeneficiaryValues/BeneficiaryMultiValues';

interface BeneficiarySectionProps extends React.PropsWithChildren {
  icon: FontAwesomeIconProps['icon'];
  heading: string;
  category: keyof Beneficiaries;
  title: JSX.Element;
  note?: JSX.Element;
  errorMessage?: string;
  setBeneficiaries: MainCategoryProps['setBeneficiaries'];
}

export const BeneficiarySectionStyles = styled.div`
  display: flex;
  margin-bottom: 48px;
  &.bottom-section {
    padding-bottom: 100px;
  }
  .content {
    width: 553px;
    button.link {
      padding: 0;
      border: none;
      background: none;
      font-size: inherit;
      cursor: pointer;
      color: ${COLORS.ctaPrimary};
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .heading {
    padding-top: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .category-heading {
    margin-bottom: 0;
  }
  button.delete-button {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0;
    border: none;
    background: none;
  }
  .icon {
    padding-right: 13px;
  }
  .cross-icon {
    margin-right: 8px;
  }
  .title {
    margin-bottom: 8px;
  }
  .note {
    margin-bottom: 2px;
  }
  .children {
    margin-top: 22px;
  }
`;

const BeneficiarySection: React.FC<BeneficiarySectionProps> = ({
  icon,
  heading,
  category,
  title,
  note,
  children,
  errorMessage,
  setBeneficiaries,
}) => {
  const handleDelete = () => {
    setBeneficiaries(s => ({ ...s, [category]: undefined }));
  };
  return (
    <BeneficiarySectionStyles>
      <div>
        <FontAwesomeIcon
          icon={icon}
          className="icon"
          size="2x"
          color={COLORS.ctaPrimary}
        />
      </div>
      <div className="content">
        <div className="heading">
          <TrueImpactText variant="heading" className="category-heading">
            {heading}
          </TrueImpactText>
          <button className="delete-button" onClick={handleDelete}>
            <FontAwesomeIcon icon={faXmark} className="cross-icon" />
            <TrueImpactText variant="body-small">
              Delete this category
            </TrueImpactText>
          </button>
        </div>
        <TrueImpactText variant="body-large" className="title">
          {title}
        </TrueImpactText>
        {note && <div className="note">{note}</div>}
        {errorMessage && (
          <ErrorText variant="body-small">{errorMessage}</ErrorText>
        )}
        <div className="children">{children}</div>
      </div>
    </BeneficiarySectionStyles>
  );
};

export default BeneficiarySection;
